import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { SearchTermservice } from '../../services/search/search-service.service';
import { Router, ActivatedRoute } from '@angular/router';
import { RegionService } from '../../services/region/region.service';
import { Region } from '../../model/region.model'
import { forEach } from '@angular/router/src/utils/collection';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { Http, Headers, RequestOptions, Response } from '@angular/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatSortModule } from '@angular/material/sort';
import { MatButtonModule, MatCheckboxModule, MatPaginatorIntl } from '@angular/material';
import { Sort } from '@angular/material';
import { MatPaginator, MatTableDataSource, MatSort } from '@angular/material';
import { SortPipe } from '../../../shared/sortPipe';
import { PageEvent } from '@angular/material';
import { ViewChild } from '@angular/core';
import { MatFormFieldModule } from '@angular/material';
import { MatInputModule } from '@angular/material';

@Component({
  selector: 'app-agentsearchlist',
  templateUrl: './agentsearchlist.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./agentsearchlist.component.css'],
})

export class AgentsearchlistComponent implements OnInit {
  errFlag: boolean = false;
  errMsgVendor: any;
  noDataFound: boolean = false;
  region = new Region();
  errmessage;
  errmsg;
  message;
  stateRegion = 'Select a Region';
  stateChange = 'Select a State';
  zipChange = '';
  agentName: any = '';
  agentId: any = '';
  regions = [];
  states = [];
  response = [];
  allStates = [];
  userName: string;
  showHide: boolean;
  searchBar;
  zipcodeBar;
  searchIcon: boolean = false;
  zipIcon: boolean = false;
  enterDisable: boolean = false;
  keyDisabled: boolean = false;
  username = new FormControl();
  iserror: boolean = true;
  iserror2: boolean = false;
  ziperror: boolean = true;
  searchTermData: any;
  data: boolean = true;
  msg: string;
  selectedRegion;
  public searchResults: any[] = [];
  sortedData;
  length: any;
  pageSize = 10;
  displayedColumns = ['MasterVendorId', 'MasterVendorName', 'RegionId', 'State', 'PostalCode', 'PlatinumCompliant', 'VendorStatus','HoldStatus'];
  dataSource: MatTableDataSource<UserData>;
  paginationFlag: boolean = false;
  platinumCompliance: boolean = true;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  searchedAgentName: any = '';
  constructor(private http: Http, private router: Router, private regionService: RegionService,
    private search: SearchTermservice, private route: ActivatedRoute) {
  }

  pageEvent: PageEvent;

  ngOnInit() {
    this.search.searchdDash.subscribe(res => {
      this.platinumCompliance = true;
      this.searchTermData = res;
      this.agentName = '';
      this.agentId = '';
      this.stateRegion = 'Select a Region';
      this.stateChange = 'Select a State';
      this.zipChange = '';
      this.searchedAgentName = '';
      this.bindAgentSearchList();
    });

    this.regionService.regionGet(this.region).subscribe(res => {
      this.selectedRegion = res.Regions;
      this.regions = [];
      this.states = [];
      this.allStates = [];
      this.selectedRegion.forEach(data => {
        this.response.push(data)
        this.regions.push(data.region);
        data.states.forEach(item => {
          this.states.push(item.code);
          this.states = this.states.filter(x => {
            return x != null;
          });
        });
      });
      this.allStates = this.states.sort();
    });

    this.searchTermData = localStorage.getItem("searchterm");
    this.bindAgentSearchList();
  }

  private bindAgentSearchList(from = '') {
    let searchAgentName = this.searchTermData;
    if (from === 'zipChange') {
      searchAgentName = this.agentName;
    }

    const regionValue = this.stateRegion === 'Select a Region' ? '' : this.stateRegion;
    const stateValue = this.stateChange === 'Select a State' ? '' : this.stateChange;

    this.search.agentSearch(searchAgentName, regionValue, stateValue, this.zipChange, this.agentId).subscribe(res => {
      if (res.Status == 200 && res.Vendors !== undefined && res.Vendors.length > 0) {
        // making array empty on each api call
        this.searchResults = [];
        for (let i = 0; i < res.Vendors.length; i++) {
          res.Vendors[i].MasterVendorName = res.Vendors[i].MasterVendorName.toLowerCase();
          if (res.Vendors[i].PlatinumCompliant != '' || res.Vendors[i].PlatinumCompliant != null) {
            res.Vendors[i].PlatinumCompliant = (res.Vendors[i].PlatinumCompliant == 'Y') ? res.Vendors[i].PlatinumCompliant = true : res.Vendors[i].PlatinumCompliant = false;
          }
          if (res.Vendors[i].VendorStatus != '' || res.Vendors[i].VendorStatus != null) {
            res.Vendors[i].VendorStatus = (res.Vendors[i].VendorStatus == 'Y') ? res.Vendors[i].VendorStatus = true : res.Vendors[i].VendorStatus = false;
          }
          if (res.Vendors[i].HoldStatus != '' || res.Vendors[i].HoldStatus != null) {
            res.Vendors[i].HoldStatus = (res.Vendors[i].HoldStatus == 'Y') ? res.Vendors[i].HoldStatus = true : res.Vendors[i].HoldStatus = false;
          }
          this.searchResults.push(res.Vendors[i])
        }
        
        this.dataSource = new MatTableDataSource(this.searchResults);
        this.message = '';
        this.length = this.searchResults.length;
        if (this.length <= 10) {
          this.paginationFlag = false;
        } else {
          this.paginationFlag = true;
        }
        this.paginator.pageIndex = 0;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        const paginatorIntl = new MatPaginatorIntl();
        paginatorIntl.itemsPerPageLabel = 'Items per page';
        paginatorIntl.nextPageLabel = 'Next page';
        paginatorIntl.previousPageLabel = 'Previous page';
        paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
          length = this.length;
          if (length == 0 || pageSize == 0) {
            return `0 from ${length}`;
          }
          length = Math.max(length, 0);
          const startIndex = page * pageSize;
          // If the start index exceeds the list length, do not try and fix the end index to the end.
          const endIndex = startIndex < length ?
            Math.min(startIndex + pageSize, length) :
            startIndex + pageSize;
          const round = Math.ceil(length / 10);
          return `${(startIndex / 10) + 1}  of ${round}`;
        };
        this.dataSource.paginator._intl = paginatorIntl;
        /*** Setting the SearchAgentName to empty, so that it won't save for the next search criteria  ***/
        searchAgentName = '';
      }
      else if (res.Vendors !== undefined && res.Vendors.length == 0) {
        this.data = false;
        this.paginationFlag = false;
        this.message = "No vendors found";
        this.dataSource = null;
      }
    }, err => {
      this.errMsgVendor = 'Vendor Service' + ' ' + err;
      this.errFlag = true;
    });
  }

  searchChange() {
    if (this.agentName.length > 2) {
      this.enterDisable = true;
      this.searchIcon = true;
    } else {
      this.enterDisable = false;
      this.searchIcon = false;
    }
  }

  zipcodeChange() {
    if (this.zipChange.length > 2) {
      this.keyDisabled = true;
      this.zipIcon = true;
    } else {
      this.zipIcon = false;
    }
  }

  onKeydown(event) {
    if (this.enterDisable) {
      this.router.navigate(['/agentsearchlist']);
    }
  }

  onZipdown(event) {
    if (this.keyDisabled) {
    }
  }

  onKeypress(event) {
    var regex = new RegExp("^[0-9]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      this.iserror = false;
      this.errmsg = "Please enter alphanumeric characters!";
      return false;
    } else {
      this.iserror = true;
      return true;
    }
  }

  onAgentname(event) {
    var zipval = new RegExp("^[a-zA-Z]");
    var zipkey = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!zipval.test(zipkey)) {
      event.preventDefault();
      this.ziperror = false;
      this.errmessage = "Please enter numeric characters!";
      return false;
    } else {
      this.ziperror = true;
      return true;
    }
  }

  regionChange() {
    if (this.stateRegion == "Select a Region") {
      this.states = this.allStates;
      this.states = this.states.filter(x => {
        return x != null;
      });
    } else {
      this.states = [];
      this.response.forEach(res => {
        if (res.region == this.stateRegion) {
          res.states.forEach(res => {
            this.states.push(res.code);
            this.states = this.states.filter(x => {
              return x != null;
            });
          });
        }
      });
    }
    this.ZipChange(this.states);
  }

  ZipChange(searchTerm) {
    this.agentName = this.searchedAgentName;
    this.selectedRegion.forEach(region => {
      return region.states.forEach(state => {
        if (state.code === searchTerm) {
          this.stateRegion = region.region;
        }
      });
    });

    if ((searchTerm === '' || searchTerm === null) && (this.agentName === '' || this.agentName === null) &&
      (this.stateChange === 'Select a State' && this.stateChange !== null) && (this.zipChange === '' || this.zipChange === null) &&
      (this.agentId === '' || this.agentId === null)) {
      this.bindAgentSearchList('zipChange');
    } else if (searchTerm === undefined) {
    } else {
      this.data = true;
      this.bindAgentSearchList('zipChange');
    }
  }

  selectedAgent(agentId) {
    localStorage.setItem("AgentId", agentId);
    this.router.navigate(['agent/dashboard', agentId, 'Dashboard']);
    let states = this.searchResults.map(data => {
      return data.State;
    });
    this.search.states.next(this.getUniqueServers(states));
  }

  getUniqueServers(totalServersArray) {
    for (let currentServer = 0; currentServer < totalServersArray.length; ++currentServer) {
      for (let nextServer = currentServer + 1; nextServer < totalServersArray.length; ++nextServer) {
        if (totalServersArray[currentServer] === totalServersArray[nextServer]) {
          totalServersArray.splice(nextServer--, 1);
        }
      }
    }
    return totalServersArray;
  }
}

export interface UserData {
  MasterVendorId: number;
  MasterVendorName: string;
  RegionId: number;
  State: string;
  PostalCode: number;
  PlatinumCompliant: string;
  VendorStatus: string;
  HoldStatus: string;
}



// WEBPACK FOOTER //
// ./src/app/components/agentsearchlist/agentsearchlist.component.ts